import React from "react";
import { Link } from "react-router-dom";
import staticData from "../../assests/staticData.json";
import { CCol } from "@coreui/react";

export default function ExpertCard() {
  const { home_expert } = staticData;

  return (
    <>
      {home_expert.length > 0 &&
        home_expert.map((expert) => (
          <CCol lg={6} key={expert.id}>
            <div className="expert-card-wrapper">
              <div className="expert-card-header">
                <div className="expert-header-image">
                  <img
                    src={require(`../../assests/${expert.expert_image}`)}
                    alt={expert.title}
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="expert-card-body text-center">
                <h5 className="s-title mt-4 mb-0">
                  <Link to={"#"}>{expert.title}</Link>
                </h5>
                <p className="themeGrayPara mb-0 in-fs lh-28">{expert.desc}</p>
              </div>
            </div>
          </CCol>
        ))}
    </>
  );
}
